import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export const API_BASE_URL = API_BASE;
